import { Reveal } from "@/components/site/motion";
import { CATEGORY_STYLE, formatNewsDate } from "@/lib/news";

export const NewsCard = ({ item, delay = 0, testid }) => (
  <Reveal
    delay={delay}
    className="group flex flex-col rounded-3xl border border-slate-200 bg-white p-7 transition-transform duration-300 hover:-translate-y-1 hover:border-cobalt/30"
    data-testid={testid}
  >
    <div className="flex items-center gap-3">
      <span className={`rounded-full px-3 py-1 text-[11px] font-semibold ${CATEGORY_STYLE[item.category] || "bg-slate-100 text-slate-600"}`}>
        {item.category}
      </span>
      <span className="text-xs font-medium text-slatey">{formatNewsDate(item.date)}</span>
    </div>
    <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-ink leading-tight">{item.title}</h3>
    <p className="mt-3 flex-1 text-[15px] leading-relaxed text-slatey">{item.excerpt}</p>
  </Reveal>
);
